/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if (typeof Shopify === "undefined") {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {
    var value = "",
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || this.money_format;

    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $("html"),
    $body: $(document.body),

    // Navigation
    $navigation: $("#AccessibleNav"),
    $mobileSubNavToggle: $(".mobile-nav__toggle"),

    // Collection Pages
    $changeView: $(".change-view"),

    // Product Page
    $productImage: $("#ProductPhotoImg"),
    $thumbImages: $("#ProductThumbs").find("a.product-single__thumbnail"),

    // Customer Pages
    $recoverPasswordLink: $("#RecoverPassword"),
    $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
    $recoverPasswordForm: $("#RecoverPasswordForm"),
    $customerLoginForm: $("#CustomerLoginForm"),
    $passwordResetSuccess: $("#ResetSuccess"),
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
    $allLinks = $nav.find("a"),
    $topLevel = $nav.children("li").find("a"),
    $parents = $nav.find(".site-nav--has-dropdown"),
    $subMenuLinks = $nav.find(".site-nav__dropdown").find("a"),
    activeClass = "nav-hover",
    focusClass = "nav-focus";

  // Mouseenter
  $parents.on("mouseenter touchstart", function (evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on("mouseleave", function () {
    hideDropdown($(this));
  });

  $subMenuLinks.on("touchstart", function (evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function () {
    handleFocus($(this));
  });

  $allLinks.blur(function () {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus($el) {
    var $subMenu = $el.next("ul"),
      hasSubMenu = $subMenu.hasClass("sub-nav") ? true : false,
      isSubItem = $(".site-nav__dropdown").has($el).length,
      $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest(".site-nav--has-dropdown").find("a");
      addFocus($newFocus);
    }
  }

  function showDropdown($el) {
    $el.addClass(activeClass);

    setTimeout(function () {
      timber.cache.$body.on("touchstart", function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off("touchstart");
  }

  function addFocus($el) {
    $el.addClass(focusClass);
  }

  function removeFocus($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers("NavDrawer", "left");

  //timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
  //'onDrawerOpen': ajaxCart.load
  //});
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on("click", function () {
    $(this).parent().toggleClass("mobile-nav--expanded");
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
    variant = options.variant,
    selector = options.selector;

  // Selectors
  var $productImage = $("#ProductPhotoImg"),
    $addToCart = $("#AddToCart"),
    $productPrice = $("#ProductPrice"),
    $comparePrice = $("#ComparePrice"),
    $quantityElements = $(".quantity-selector, label + .js-qty"),
    $addToCartText = $("#AddToCartText");

  if (variant) {
    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
        el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass("disabled").prop("disabled", false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass("disabled").prop("disabled", true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(
          "Compare at" +
            " " +
            Shopify.formatMoney(variant.compare_at_price, moneyFormat)
        )
        .show();
    } else {
      $comparePrice.hide();
    }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass("disabled").prop("disabled", true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on("click", function (evt) {
      evt.preventDefault();
      var newImage = $(this).attr("href");
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr("src", src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $(
    'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'
  );
  var $iframeReset = $iframeVideo.add("iframe#admin_bar_iframe");

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on("click", function () {
      var view = $(this).data("view"),
        url = document.URL,
        hasParams = url.indexOf("?") > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, "view", view);
      } else {
        window.location = url + "?view=" + view;
      }
    });
  }
};

timber.loginForms = function () {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on("click", function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on("click", function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == "#recover") {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function () {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + position,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position,
    };

    this.$nodes = {
      parent: $("body, html"),
      page: $("#PageContainer"),
      moved: $(".is-moved-by-drawer"),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on("click", $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger("beforeDrawerOpen.timber", this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass("is-transitioning");
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(
      this.config.openClass + " " + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, "drawer_focus");

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen == "function"
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    // Lock scrolling on mobile
    this.$nodes.page.on("touchmove.drawer", function () {
      return false;
    });

    this.$nodes.page.on(
      "click.drawer",
      $.proxy(function () {
        this.close();
        return false;
      }, this)
    );

    // Notify the drawer has opened
    timber.cache.$body.trigger("afterDrawerOpen.timber", this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger("beforeDrawerClose.timber", this);

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(
      this.config.dirOpenClass + " " + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, "drawer_focus");

    this.$nodes.page.off(".drawer");

    // Notify the drawer is closed now
    timber.cache.$body.trigger("afterDrawerClose.timber", this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? "focusin." + eventNamespace : "focusin";

    $container.attr("tabindex", "-1");

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? "focusin." + eventNamespace : "focusin";

    $container.removeAttr("tabindex");
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

/*======================================================================================================================
on-load classes
======================================================================================================================*/
document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('body').classList.add('loaded');

    // Init Animate On Scroll
    AOS.init();
});
/*======================================================================================================================
popover
======================================================================================================================*/
$(document).ready(function() {
    $(function() {
        $('[data-toggle="popover"]').popover();
    });
});
/*======================================================================================================================
off_canvas_menu_b
======================================================================================================================*/
$(document).ready(function() {
    $('.off_canvas_menu_toggle.a,.off_canvas_overlay.a').click(function() {
        $('.off_canvas_menu.a').toggleClass('active');
        $('.off_canvas_overlay.a').toggleClass('active');
        $('.on_canvas').toggleClass('active');
        // $("body").toggleClass("ocm_active");
        let body = $('body');
        if (body.hasClass('ocm_active')) {
            setTimeout(function() {
                body.removeClass('ocm_active');
            }, 500);
        } else {
            body.addClass('ocm_active');
        }
    });
});
/*======================================================================================================================
off_canvas_menu_b
======================================================================================================================*/
$(document).ready(function() {
    $('.off_canvas_menu_toggle.b,.off_canvas_overlay.b').click(function() {
        $('.off_canvas_menu.b').toggleClass('active');
        $('.off_canvas_overlay.b').toggleClass('active');
        $('.on_canvas').toggleClass('active');
        // $("body").toggleClass("ocm_active");
        let body = $('body');
        if (body.hasClass('ocm_active')) {
            setTimeout(function() {
                body.removeClass('ocm_active');
            }, 500);
        } else {
            body.addClass('ocm_active');
        }
    });
});
/*======================================================================================================================
off_canvas_menu_c
======================================================================================================================*/
$(document).ready(function() {
    $('.off_canvas_menu_toggle.c,.off_canvas_overlay.c').click(function() {
        $('.off_canvas_menu.c').toggleClass('active');
        $('.off_canvas_overlay.c').toggleClass('active');
        $('.on_canvas').toggleClass('active');
        // $("body").toggleClass("ocm_active");
        let body = $('body');
        if (body.hasClass('ocm_active')) {
            setTimeout(function() {
                body.removeClass('ocm_active');
            }, 500);
        } else {
            body.addClass('ocm_active');
        }
    });
});
/*======================================================================================================================
off_canvas_menu_d
======================================================================================================================*/
$(document).on(
    'click',
    '.off_canvas_menu_toggle.d,.off_canvas_overlay.d',
    function() {
        $('.off_canvas_menu.d').toggleClass('active');
        $('.off_canvas_overlay.d').toggleClass('active');
        $('.on_canvas').toggleClass('active');
        // $("body").toggleClass("ocm_active");
        let body = $('body');
        if (body.hasClass('ocm_active')) {
            setTimeout(function() {
                body.removeClass('ocm_active');
            }, 500);
        } else {
            body.addClass('ocm_active');
        }
    }
);
/*======================================================================================================================
off_canvas_menu_e
======================================================================================================================*/
$(document).on(
    'click',
    '.off_canvas_menu_toggle.e,.off_canvas_overlay.e',
    function() {
        $('.off_canvas_menu.e').toggleClass('active');
        $('.off_canvas_overlay.e').toggleClass('active');
        $('.on_canvas').toggleClass('active');
        // $("body").toggleClass("ocm_active");
        let body = $('body');
        if (body.hasClass('ocm_active')) {
            setTimeout(function() {
                body.removeClass('ocm_active');
            }, 500);
        } else {
            body.addClass('ocm_active');
        }
    }
);
/*======================================================================================================================
off_canvas_menu_f
======================================================================================================================*/
$(document).on(
    'click',
    '.off_canvas_menu_toggle.f,.off_canvas_overlay.f',
    function() {
        $('.off_canvas_menu.f').toggleClass('active');
        $('.off_canvas_overlay.f').toggleClass('active');
        $('.on_canvas').toggleClass('active');
        // $("body").toggleClass("ocm_active");
        let body = $('body');
        if (body.hasClass('ocm_active')) {
            setTimeout(function() {
                body.removeClass('ocm_active');
            }, 500);
        } else {
            body.addClass('ocm_active');
        }
    }
);
/*======================================================================================================================
numbers_only field
======================================================================================================================*/
let goodKey = '0123456789+';
let filterInput = function(val) {
    return goodKey.indexOf(val) > -1;
};
document.addEventListener('input', function(event) {
    if (event.target.matches('.numbers_only')) {
        // must be exact target, parent-child sensitive
        let key = typeof event.which === 'number' ? event.which : event.keyCode;
        let start = event.target.selectionStart,
            end = event.target.selectionEnd;

        let filtered = event.target.value.split('').filter(filterInput);
        event.target.value = filtered.join('');

        /* Prevents moving the pointer for a bad character */
        let move =
            filterInput(String.fromCharCode(key)) || key === 0 || key === 8
                ? 0
                : 1;
        event.target.setSelectionRange(start - move, end - move);
    }
});
/*======================================================================================================================
smooth scroll
======================================================================================================================*/
/*
// Disabled since we don't want to overwrite the window method this way
function scrollTo(destination, duration = 200, easing = "linear", callback) {
  console.log(destination, duration, easing, callback);
  if (destination === 0) {
    return false;
  }

  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    },
  };
  const start = window.pageYOffset;
  const startTime =
    "now" in window.performance ? performance.now() : new Date().getTime();
  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  );
  const windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName("body")[0].clientHeight;
  const destinationOffset =
    typeof destination === "number" ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(
    documentHeight - destinationOffset < windowHeight
      ? documentHeight - windowHeight
      : destinationOffset
  );
  if ("requestAnimationFrame" in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }
  function scroll() {
    const now =
      "now" in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, (now - startTime) / duration);
    const timeFunction = easings[easing](time);
    window.scroll(
      0,
      Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start)
    );
    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }
    requestAnimationFrame(scroll);
  }
  scroll();
}
*/
//
function scrollPageTo(to, duration = 500) {
    //t = current time
    //b = start value
    //c = change in value
    //d = duration
    const easeInOutQuad = function(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    };
    return new Promise((resolve, reject) => {
        const element = document.scrollingElement;
        if (typeof to === 'string') {
            to = document.querySelector(to) || reject();
        }
        if (typeof to !== 'number') {
            to = to.getBoundingClientRect().top + element.scrollTop;
        }
        let start = element.scrollTop,
            change = to - start,
            currentTime = 0,
            increment = 20;
        const animateScroll = function() {
            currentTime += increment;
            let val = easeInOutQuad(currentTime, start, change, duration);
            element.scrollTop = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            } else {
                resolve();
            }
        };
        animateScroll();
    });
}
// * window.scrollPageTo('#some-section', 2000);
// * window.scrollPageTo(document.getElementById('some-section'), 1000);
// * window.scrollPageTo(500); // will scroll to 500px in 500ms
document.addEventListener('click', function(event) {
    if (event.target.matches('[data-scroll-to]')) {
        // must be exact target, parent-child sensitive
        let scrollToSection = event.target.getAttribute('data-scroll-to');
        window.scrollPageTo(scrollToSection, 500);
    }
});
/*======================================================================================================================
display_toggles
======================================================================================================================*/
$(document).ready(function() {
    // display horizontal slide
    $('.display_hs_toggle').click(function() {
        $(
            '[data-display-hs="' + $(this).data('display-hs-target') + '"]'
        ).animate({
            width: 'toggle',
        });
    });
});
/*======================================================================================================================
restore_opacity
======================================================================================================================*/
// restore_opacity function
function restore_opacity() {
    $('.restore_opacity').each(function() {
        var opacity_1 = 1;
        $(this).css({
            opacity: opacity_1,
        });
    });
}
/*======================================================================================================================
replace all SVG images (with "svg" class) with inline SVG
======================================================================================================================*/
// call on page load
$(document).ready(function() {
    jQuery('img.svg').each(function() {
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(
            imgURL,
            function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Add crossorigin="anonymous" attr to the new SVG
                $svg.attr('crossorigin', 'anonymous');

                // Replace image with new SVG
                $img.replaceWith($svg);
            },
            'xml'
        );
    });
});
/*======================================================================================================================
player effects
======================================================================================================================*/
// video handler
$(document).ready(function() {
    /////////////////////////////////////////////////////
    // ux optimization / pause all video on tab hidden //
    /////////////////////////////////////////////////////
    (function() {
        let hidden = 'hidden';
        // standards:
        if (hidden in document)
            document.addEventListener('visibilitychange', onchange);
        else if ((hidden = 'mozHidden') in document)
            document.addEventListener('mozvisibilitychange', onchange);
        else if ((hidden = 'webkitHidden') in document)
            document.addEventListener('webkitvisibilitychange', onchange);
        else if ((hidden = 'msHidden') in document)
            document.addEventListener('msvisibilitychange', onchange);
        // IE 9 and lower:
        else if ('onfocusin' in document)
            document.onfocusin = document.onfocusout = onchange;
        // all others:
        else
            window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;
        function onchange(evt) {
            // document.getElementById("video").pause();
            // $("video").trigger("pause");
            // $(".mejs__poster").css("display", "block");
        }
        // set the initial state (but only if browser supports the Page Visibility API)
        if (document[hidden] !== undefined)
            onchange({ type: document[hidden] ? 'blur' : 'focus' });
    })();
    
    ///////////////////////////////////////
    // pause video on click and spacebar //
    ///////////////////////////////////////
    if ($('video').length > 0) {
        $('body').keyup(function(e) {
            if (e.keyCode == 32) {
                $('video').each(function() {
                    toggleVideoPlayback(this);
                });
            }
        });
        
        $('video').on('click', function() {
            toggleVideoPlayback(this);
        });
    }
    
    function toggleVideoPlayback(videoElement) {
        if (videoElement.paused == true) {
            videoElement.play();
        } else {
            videoElement.pause();
        }
    }
});
/*======================================================================================================================
scroll effects
======================================================================================================================*/
// function, aplus scroll effects
function section_scroll_effects() {
    let section = $('.section');
    let target = $('.aplus_target');
    // if target exist (section scroll actions)
    if (target.length) {
        let target_height = target.height();
        let target_top_distance_to_window_top = target.offset().top;
        let target_bottom_distance_to_window_top =
            target.offset().top + target_height;
        let apply_aplus = $('.apply_aplus');
        let apply_aplus_scheme = $('.apply_aplus_scheme');
        // run globally (when using just one target for all style changes)
        section.each(function() {
            // if this section top distance to window top is less than or equal to the target bottom distance to window top
            // basically: when top of this section passes the target
            if ($(this).offset().top <= target_bottom_distance_to_window_top) {
                var last_section_passing_this_target = $(this).last();
                // active class (disabled when fp autoscroll is enabled)
                // remove active class from all sections and add active class to loaded section
                section.removeClass('active');
                last_section_passing_this_target.addClass('active');
                // aplus boogie
                // if the target bottom distance to window top is greater than the last section to pass this target
                // basically: when the target gets passed by the last section
                if (
                    target_bottom_distance_to_window_top >
                    last_section_passing_this_target.offset().top
                ) {
                    apply_aplus_scheme.attr(
                        'data-aplus-scheme',
                        last_section_passing_this_target.data('aplus-scheme')
                    );
                    apply_aplus_scheme.attr(
                        'data-aplus-sections-bg-color',
                        last_section_passing_this_target.data(
                            'aplus-sections-bg-color'
                        )
                    );
                    apply_aplus_scheme.attr(
                        'data-aplus-mode',
                        last_section_passing_this_target.data('aplus-mode')
                    );
                    // add section name to body
                    apply_aplus_scheme.attr(
                        'data-aplus-active-section',
                        last_section_passing_this_target.data(
                            'aplus-active-section'
                        )
                    );
                    apply_aplus_scheme.attr(
                        'data-aplus-first-section',
                        last_section_passing_this_target.data(
                            'aplus-first-section'
                        )
                    );
                    $('.globe_').attr(
                        'data-aplus-globe-position',
                        last_section_passing_this_target.data(
                            'aplus-globe-position'
                        )
                    );
                    $('.globe_').attr(
                        'data-aplus-globe-active',
                        last_section_passing_this_target.data(
                            'aplus-globe-active'
                        )
                    );
                    $('.title_').attr(
                        'data-aplus-title-active',
                        last_section_passing_this_target.data(
                            'aplus-title-active'
                        )
                    );
                    $('.side_menu').attr(
                        'data-aplus-alt-menu-active',
                        last_section_passing_this_target.data(
                            'aplus-alt-menu-active'
                        )
                    );
                }
            }
        });
    }
    // if scrolled to top of window
    if (window.scrollY === 0) {
        // document.querySelector(".sections").classList.remove('split');
        // document.querySelector(".recently").classList.remove('show_');
    }
}
// function, play first video of active section
function play_active_section_video() {
    setTimeout(function() {
        if ($('.sections .active').hasClass('has_video')) {
            if (
                $(
                    '.sections .active .blockrow .slick-active .blockrow_item'
                ).hasClass('video')
            ) {
                // $("video").trigger('pause');
                // $(".mejs__poster").css("display", "block");
                $(
                    '.sections .active .blockrow .slick-active video'
                )[0].player.play();
            } else {
                // $("video").trigger('pause');
                // $(".mejs__poster").css("display", "block");
                $('.sections .active video')[0].player.play();
            }
        }
    }, 500);
}
// function, toggle class on scroll
function toggle_on_scroll() {
    // add class on scroll
    $('.hide_on_scroll').addClass('display_none');
    // remove class on scroll stop
    clearTimeout($.data(this, 'scrollCheck'));
    $.data(
        this,
        'scrollCheck',
        setTimeout(function() {
            $('.hide_on_scroll').removeClass('display_none');
        }, 250)
    );
}
// call on page load
$(document).ready(function() {
    section_scroll_effects();
});
// call on scroll
$(window).scroll(function() {
    section_scroll_effects();
    play_active_section_video();
    toggle_on_scroll();
});
// call on window resize
$(window).on('resize', function() {
    section_scroll_effects();
});
// call on ajaxStop
$(document).ajaxStop(function() {});
// section navigation and other
$(document).ready(function() {
    // functions, section scroll
    function scroll_to_previous_section() {
        var current_element = $('.sections .active');
        var previous_element = current_element.prev('.section');
        // Check if previous element actually exists
        if (previous_element.length) {
            // if yes, update $currentElement and scroll position
            current_element = previous_element;
            $('html, body')
                .stop(true)
                .animate(
                    {
                        scrollTop: previous_element.offset().top,
                    },
                    500
                );
        }
        return false;
    }
    function scroll_to_next_section() {
        var current_element = $('.sections .active');
        var next_element = current_element.next('.section');
        // Check if next element actually exists
        if (next_element.length) {
            // if yes, update $currentElement and scroll position
            current_element = next_element;
            $('html, body')
                .stop(true)
                .animate(
                    {
                        scrollTop: next_element.offset().top,
                    },
                    500
                );
        }
        return false;
    }
    $('.previous_section').click(function() {
        scroll_to_previous_section();
    });
    $('.next_section').click(function() {
        scroll_to_next_section();
    });
    $('.scroll_to_section').click(function(e) {
        var section = $(this).data('scroll-to');
        $('html, body').animate(
            {
                scrollTop: $(section).offset().top,
            },
            500
        );
    });
});
/*======================================================================================================================
carousel effects
======================================================================================================================*/
function five_card_carousel_slide_video_boogie() {
    setTimeout(function() {
        // stop all carousel video
        let sicv = document.querySelectorAll('#five_card_carousel video'),
            sicv_i;
        for (sicv_i = 0; sicv_i < sicv.length; ++sicv_i) {
            // sicv[sicv_i].trigger('pause');
            // sicv[sicv_i].pause();
            sicv[sicv_i].player.pause();
        }
        //  play active slide video
        if (
            document
                .querySelector('#five_card_carousel .carousel-item.active')
                .classList.contains('has_video')
        ) {
            document
                .querySelector(
                    '#five_card_carousel .carousel-item.active video'
                )
                .player.play();
        }
    }, 500);
}
function five_card_carousel_populate_slide_info() {
    if (document.querySelector('#five_card_carousel')) {
        let slideCurrentIndex = document
            .querySelector('#five_card_carousel .carousel-item.active')
            .getAttribute('data-slide-index');
        let slideInfo = document
            .querySelector('#five_card_carousel .carousel-item.active')
            .getAttribute('data-slide-info');
        document.querySelector(
            '.carousel_navigation_ .current_index'
        ).innerHTML = slideCurrentIndex;
        // document.querySelector(".carousel_navigation_ .slide_info").innerHTML = slideInfo;
    }
}
// on page load
document.addEventListener('DOMContentLoaded', function() {
    // five_card_carousel_slide_video_boogie();
    five_card_carousel_populate_slide_info();
    setTimeout(function() {
        five_card_carousel_populate_slide_info();
    }, 3000);
});
// on click
document.addEventListener('click', function(event) {
    if (event.target.matches('.carousel_navigation_next *')) {
        // must be exact target, parent-child sensitive
        // five_card_carousel_slide_video_boogie();
        $('#five_card_carousel').carousel('next');
        // five_card_carousel_populate_slide_info();
    }
});
// on carousel slide end
$(document).ready(function() {
    $('#five_card_carousel').on('slid.bs.carousel', function() {
        five_card_carousel_populate_slide_info();
    });
});
/*======================================================================================================================
optimization
======================================================================================================================*/
// pause ticker after time
setTimeout(function() {
    // $(".events_ticker").webTicker('stop');
}, 180000);
// pause ticker after time
setTimeout(function() {
    $('.word_cycle').carousel('pause');
}, 60000);
// pause ticker after time
$('.stop_all_animations_and_video').click(function() {
    // $(".events_ticker").webTicker('stop');
    $('.word_cycle').carousel('pause');
    $('video').trigger('pause');
    $('.mejs__poster').css('display', 'block');
});
/*======================================================================================================================
mailchimp json
======================================================================================================================*/
$(document).ready(function() {
    var $form = $('#mc-embedded-subscribe-form');
    if ($form.length > 0) {
        $('form .submit_mc_form').bind('click', function(event) {
            if (event) event.preventDefault();
            register($form);
        });
    }
});
function register($form) {
    $('#mc-embedded-subscribe').val('Sending');
    $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache: false,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        error: function(err) {
            alert(
                'Could not connect to the registration server. Please try again later.'
            );
        },
        success: function(data) {
            $('#mc-embedded-subscribe').val('SUBMIT');
            if (data.result === 'success') {
                // Yeahhhh Success
                console.log(data.msg);
                $('#mce-EMAIL').css('borderColor', '#ffffff');
                $('#mce-NAME').css('borderColor', '#ffffff');
                $('#mce-MESSAGE').css('borderColor', '#ffffff');
                $('#subscribe-result').css('color', '#7cfc00');
                $('#subscribe-result').html('Thank you for your interest.');
                $('#mce-EMAIL').val('');
                $('#mce-NAME').val('');
                $('#mce-MESSAGE').val('');
            } else {
                // Something went wrong, do something to notify the user.
                console.log(data.msg);
                $('#mce-EMAIL').css('borderColor', '#ff0000');
                $('#mce-NAME').css('borderColor', '#ff0000');
                $('#mce-MESSAGE').css('borderColor', '#ff0000');
                $('#subscribe-result').css('color', '#ff0000');
                $('#subscribe-result').html(data.msg.substring(4));
            }
        },
    });
}
